import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import 'react-quill/dist/quill.snow.css';
import {Tabs, Tab} from 'material-ui/Tabs';
import Questions from '../components/Questions';
import {DETAILS, VIDEO, PODCAST, QUIZ} from 'constants/topicTabs';
import {inject, observer} from 'mobx-react';
import HttpClient from 'services/HttpClient';

const TOPICS_REQUEST = '/api/v1/tutorials/';
const ANSWERS = '/api/v1/results/';
const QUESTIONS_ANSWERS = '/api/v1/results/set_result';

const EMPTY_CPD_QUIZES = [
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  },
  {
    question: '',
    correct: ''
  }
];

@withRouter
@inject('userStore')
@inject('topicsStore')
@inject('alertStore')
@inject('examPrepHeaderStore')
@observer
class TopicOnlyQuiz extends Component {
  state = {
    selectedTab: QUIZ,
    topic: null,
    answers: [{}],
    selectedQuiz: 0,
    quizResult: null
  };

  extractContent = description => {
    const span = document.createElement('span');
    span.innerHTML = description;
    return span.textContent || span.innerText;
  }

  componentWillMount() {
    const {topicsStore, location, userStore, match, examPrepHeaderStore: {setTopic}} = this.props;
    const id = match.params.id;//location.pathname.replace('/topic/', '');

    if(id) {
      if(!userStore.user && Number(id) === 11) {

        new HttpClient().get(`${TOPICS_REQUEST}show_tutorial`).then(data => {
          const topic = data.body.data.tutorial;
          const topicWithVideo = {
            ...topic,
            tutorial_videos_attributes: topic.videos,
            podcasts_attributes: topic.podcasts,
          }
          const spd_quizzes = topic.spd_quizzes;
          let sortedQuizz = spd_quizzes.length > 0 ? _.sortBy(spd_quizzes, 'id') : EMPTY_CPD_QUIZES;
          sortedQuizz = topic.reimbursement_type === 'regular' ? sortedQuizz : sortedQuizz.map(quiz => {
            const options = quiz.options.map(option => JSON.parse((option || '').replaceAll('=>', ':')));

            return {
              ...quiz,
              options,
            };
          });
          const withDescription = !!this.extractContent(topic.description);
          const topicWithSortedQuizz = {
            ...topicWithVideo,
            withDescription,
            spd_quizzes: sortedQuizz,
          };
          topicsStore.setTopic(topicWithSortedQuizz);

          if (topic.tutorial_type !== 'regular') {
            setTopic(topic);
          }

          this.setState({
            topic: topicWithSortedQuizz,
            answers: [{[topicWithSortedQuizz.spd_quizzes[0].id]: topic.reimbursement_type === 'cct' ? [] : ''}],
          });
          // this.setState({
          //   topic: topicWithSortedQuizz, answers: [{[topicWithSortedQuizz.spd_quizzes[0].id]: ''}]
          // });
          // this.props.topicsStore.setTopic(topic);
        }).catch( (e) => {
          if(e.status === 403) {
            this.props.history.push('/settings/payments');
          }
        });
      } else {

        new HttpClient().get(`${TOPICS_REQUEST}${id}`).then(data => {
          const topic = data.body.data.tutorial;
          const spd_quizzes = topic.spd_quizzes;
          let sortedQuizz = spd_quizzes.length > 0 ? _.sortBy(spd_quizzes, 'id') : EMPTY_CPD_QUIZES;
          sortedQuizz = topic.reimbursement_type === 'regular' ? sortedQuizz : sortedQuizz.map(quiz => {
            const options = quiz.options.map(option => JSON.parse((option || '').replaceAll('=>', ':')));

            return {
              ...quiz,
              options,
            };
          });

          const topicWithVideo = {
            ...topic,
            tutorial_videos_attributes: topic.videos,
            podcasts_attributes: topic.podcasts,
          }
          const withDescription = !!this.extractContent(topic.description);
          const topicWithSortedQuizz = {
            ...topicWithVideo,
            withDescription,
            spd_quizzes: sortedQuizz,
          };
          topicsStore.setTopic(topicWithSortedQuizz);

          if (topic.tutorial_type !== 'regular') {
            setTopic(topic);
          }

          this.setState({
            topic: topicWithSortedQuizz,
            answers: [{[topicWithSortedQuizz.spd_quizzes[0].id]: topic.reimbursement_type === 'cct' ? [] : ''}]
          });//, answers: [{[topicWithSortedQuizz.spd_quizzes[0].id]: ''}]});
          // this.props.topicsStore.setTopic(topic);
        }).catch( (e) => {
          console.log(e)
          if(e.status === 403) {
            this.props.history.push('/settings/payments');
          }
        });
      }
    }
  }

  componentWillUnmount() {
    this.props.topicsStore.initNewTopic();
  }

  handleChange = selectedTab => {
    this.setState({selectedTab});
  };

  selectQuiz = selectedQuiz => {
    this.setState({selectedQuiz, quizResult: null});
  }

  onQuestionAnswerEdit = (e, index) => {
    const {id, value} = e.target || {};
    const { answers, selectedQuiz } = this.state;
    const newAnswers = [...answers];
    const newAnswerObject = newAnswers[selectedQuiz];
    const options = [...newAnswerObject[id]];
    const answerIndex = options.map(option => Object.keys(option)[0]).indexOf(`answer_${index}`);

    if (answerIndex !== -1) {
      options.splice(answerIndex, 1);
    } else {
      options.push({[`answer_${index}`]: value});
    }

    newAnswerObject[id] = options;

    this.setState({
      answers: newAnswers,
    });
  }

  onAnswerEdit = (e, value) => {
    const { answers, selectedQuiz } = this.state;
    const newAnswers = [...answers];
    const newAnswerObject = newAnswers[selectedQuiz];
    newAnswerObject[e.target.id] = value;

    this.setState({
      answers: newAnswers
    });
  }

  onNextQuestion = () => {
    const { topic, selectedQuiz, answers } = this.state;
    const newAnswers = [...answers];

    newAnswers.push({ [topic.spd_quizzes[selectedQuiz + 1].id]: '' });

    this.setState({selectedQuiz: selectedQuiz + 1, answers: newAnswers});
  }

  submitAnswers = event => {
    event.preventDefault();
    const { topic, answers } = this.state;
    if (topic.reimbursement_type !== 'ckt') {
      const answersObject = {};
      answers.forEach(answer => {
        const key = Object.keys(answer)[0];

        answersObject[key] = answer[key] === 'true';
      });

      new HttpClient().post(ANSWERS, { answers: answersObject, id: topic.id })
      .then(response => {
        if(response.body.completed === 'you completed')
          this.setState({quizResult: response.body.quiz_result, selectedQuiz: 0, answers: [{}]});
      })
      .catch(e => {
        this.setState({quizResult: e.body.quiz_result, selectedQuiz: 0, answers: [{}]});
      });
    } else {
      // const correctCount = answers.filter(answer => Object.values(answer)[0] === 'true').length;
      const quizCorrects = topic.spd_quizzes.map(quiz => quiz.options.filter(option => option.correct === 'true').length)
      const allAnswers = answers.map(id => id[Object.keys(id)[0]]).map((option) => option.map((answer) => answer[Object.keys(answer)[0]]));
      const correctAnswersLength = allAnswers.map(answer => answer.filter(correct => answer.indexOf('false') === -1 && correct === 'true').length);
      const answersCount = correctAnswersLength.filter((correctLength, index) => quizCorrects[index] === correctLength).length;

      new HttpClient().post(QUESTIONS_ANSWERS, { answers_count: answersCount, id: topic.id })
      .then(response => {
        if(response.body.completed === 'you completed')
          this.setState({quizResult: response.body.answers_count || answersCount, selectedQuiz: 0, answers: [{}]});
      })
      .catch(e => {
        this.setState({quizResult: e.body.answers_count || answersCount, selectedQuiz: 0, answers: [{}]});
      });
    }
  }

  render() {
    const {selectedTab, answers, selectedQuiz, quizResult} = this.state;
    const {topicsStore} = this.props;

    return (
      <section className="section topic-edit" style={{overflow: 'scroll'}}>
        <div className="container-fluid">
          <div className="row">
            <div className="container justify-content-center">
              <div className="edit-container">
                
                <Tabs
                  value={selectedTab}
                  onChange={this.handleChange}
                  inkBarStyle={{background: '#28b5f4'}}
                  className='course-tabs-component'
                >
                  <Tab
                    label="quiz"
                    className='tab-btn'
                    value={QUIZ}
                  >
                      <Questions
                        id={topicsStore.topic.id}
                        completed={topicsStore.topic.completed}
                        answer={answers[selectedQuiz]}
                        selectedQuiz={selectedQuiz}
                        quiz={topicsStore.topic.spd_quizzes[selectedQuiz]}
                        onAnswerEdit={this.onAnswerEdit}
                        onNextQuestion={this.onNextQuestion}
                        submitAnswers={this.submitAnswers}
                        quizResult={quizResult}
                        disabled={answers[selectedQuiz][topicsStore.topic.spd_quizzes[selectedQuiz].id]}
                        selectQuiz={this.selectQuiz}
                        isQuiz={topicsStore.topic.reimbursement_type !== 1 && topicsStore.topic.reimbursement_type !== 'ckt'}
                        onQuestionAnswerEdit={this.onQuestionAnswerEdit}
                      />
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
} 

export default TopicOnlyQuiz;


// WEBPACK FOOTER //
// ./src/modules/topic/containers/TopicOnlyQuiz.js